import { PaymentMethod } from '../../../../types';
import { isValidCPF, isValidCreditCardNumber, isValidCVV, isValidExpiryDate } from '../../../../utils/validation';
import type { PaymentFormErrors, PaymentFormState } from '../types/payment-form.types';

export const validatePaymentForm = (
  state: PaymentFormState,
  opts?: { useStripeElements?: boolean; usePagouElements?: boolean },
): PaymentFormErrors => {
  const { selectedMethod, creditCardData, pixData, boletoData } = state;
  const errors: PaymentFormErrors = {};
  const useStripeElements = opts?.useStripeElements === true;
  const usePagouElements = opts?.usePagouElements === true;

  if (!selectedMethod) {
    errors.paymentMethod = 'Selecione um método de pagamento.';
  }

  if (selectedMethod === PaymentMethod.CREDIT_CARD) {
    if (!useStripeElements && !usePagouElements) {
      if (!creditCardData.cardNumber.trim() || !isValidCreditCardNumber(creditCardData.cardNumber)) {
        errors.cardNumber = 'Número do cartão inválido.';
      }
      if (!creditCardData.expirationDate.trim() || !isValidExpiryDate(creditCardData.expirationDate)) {
        errors.expirationDate = 'Data de validade inválida (MM/AA).';
      }
      if (!creditCardData.cvv.trim() || !isValidCVV(creditCardData.cvv)) {
        errors.cvv = 'CVV inválido.';
      }
      if (!creditCardData.cardholderName.trim()) {
        errors.cardholderName = 'Nome do titular é obrigatório.';
      }
      if (!(creditCardData.cpf ?? '').trim() || !isValidCPF(creditCardData.cpf ?? '')) {
        errors.cpf = 'CPF do titular inválido.';
      }
      if (!creditCardData.installments) {
        errors.installments = 'Selecione o número de parcelas.';
      }
    }
    // Stripe/Pagou Elements: PAN no iframe; CPF vem da identificação (cart) ou do campo CPF abaixo.
    // Com Pagou o campo CPF continua visível — validar se preenchido; se vazio, cart/identificação cobre.
    if (useStripeElements || usePagouElements) {
      const cpf = (creditCardData.cpf ?? '').trim();
      if (cpf && !isValidCPF(cpf)) {
        errors.cpf = 'CPF do titular inválido.';
      }
      if (!creditCardData.installments) {
        errors.installments = 'Selecione o número de parcelas.';
      }
    }
  } else if (selectedMethod === PaymentMethod.PIX) {
    if (!pixData.cpf.trim() || !isValidCPF(pixData.cpf)) {
      errors.cpfPix = 'CPF para PIX inválido.';
    }
  } else if (selectedMethod === PaymentMethod.BOLETO) {
    if (!boletoData.cpf.trim() || !isValidCPF(boletoData.cpf)) {
      errors.cpfBoleto = 'CPF para Boleto inválido.';
    }
  }

  return errors;
};

export const hasErrors = (errors: PaymentFormErrors): boolean => {
  return Object.keys(errors).length > 0;
}; 